import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { UserState } from 'src/app/_shared/state/user.state';
import constants from 'src/constant.json';
import { CmaService } from '../../../cma/cma.service';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';

@Component({
  selector: 'app-lead-dashboard',
  templateUrl: './lead-dashboard.component.html',
  styleUrls: ['./lead-dashboard.component.scss'],
})
export class LeadDashboardComponent implements OnInit {
  onDestroyNotifier$ = new Subject();
  logActivityDetails: any;
  userType: string;
  objectKeys = Object.keys;
  isLoadingLeadDetails: boolean;
  totalCount: number;
  constant: any = constants;
  @Output() changeTab = new EventEmitter<any>();
  @Output() changeToMarketingTab = new EventEmitter<any>();
  activeUsers: Number;
  recentlyActiveUsers: Number;
  cmaReadCount: any;
  cmaSentCount: any;

  constructor(
    private clientDashboardService: ClientDashboardService,
    public clientDashboardState: ClientDashboardState,
    public authorizeService: AuthorizeService,
    public userState: UserState,
    public cmaService: CmaService
  ) { }

  ngOnInit() {
    this.userState.userDetail$
      .pipe(
        takeUntil(this.onDestroyNotifier$),
        filter(res => !!res), take(1)
      )
      .subscribe(() => {
        this.fetchLeadsDetails();
      });

    this.clientDashboardState.logCountLeadDashboard$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((logActivity: any) => {
        if (logActivity) {
          this.logActivityDetails = logActivity;
          this.activeUsers = this.logActivityDetails.activeGuestUsers + this.logActivityDetails.activeUsers;
          this.recentlyActiveUsers =
            this.logActivityDetails.recentlyActiveGuestUsers + this.logActivityDetails.recentlyActiveUsers;
          if (this.logActivityDetails.buyerLead) {
            let buyerLeadTag = { nurturing: [], qualified: [], customer: [], client: [], canceled: [] };
            Object.values(this.logActivityDetails?.buyerLead).forEach((buyer: any) => {
              if (buyer.isNurturing) buyerLeadTag.nurturing.push(buyer);
              if (buyer.isCustomer) buyerLeadTag.customer.push(buyer);
              if (buyer.isQualified) buyerLeadTag.qualified.push(buyer);
              if (buyer.isClient) buyerLeadTag.client.push(buyer);
              if (buyer.isCanceled) buyerLeadTag.canceled.push(buyer);
            });
            this.logActivityDetails.buyerLead = buyerLeadTag;
          }
          let sellerLeadTag = { nurturing: [], qualified: [], customer: [], client: [], canceled: [] };
          if (this.logActivityDetails.sellerLead) {
            Object.values(this.logActivityDetails?.sellerLead).forEach((seller: any) => {
              if (seller.isNurturing) sellerLeadTag.nurturing.push(seller);
              if (seller.isCustomer) sellerLeadTag.customer.push(seller);
              if (seller.isQualified) sellerLeadTag.qualified.push(seller);
              if (seller.isClient) sellerLeadTag.client.push(seller);
              if (seller.isCanceled) sellerLeadTag.canceled.push(seller);
            });
            this.logActivityDetails.sellerLead = sellerLeadTag;
          }
        }
      });

    this.getCmaReportStat();
  }

  fetchLeadsDetails() {
    this.clientDashboardService
      .leadDashboardLogs()
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((loading: any) => {
        this.isLoadingLeadDetails = loading.isLoading;
      });
  }

  getCmaReportStat() {
    this.cmaService.shareCmaReportStatistics().subscribe({
      next: (response) => {
        if (response.error) {
          console.error('Error fetching report stat:', response.error);
        } else {
          if (response && response.status == 'OK') {
            this.cmaReadCount = response?.data?.cmaEmailReadCount
            this.cmaSentCount = response?.data?.cmaEmailSentCount
          }
        }
      },
      error: (err) => console.error('Unexpected error:', err),
      complete: () => { },
    });
  }


  navigateToMyClients(value) {
    this.changeTab.emit(value);
  }

  navigateToMarketingTab(value) {
    this.changeToMarketingTab.emit(value);
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
